import { useState, useEffect } from 'react';

/**
 * @author Alexey Rezakov <a.rezakov@rambler-co.ru>
 *
 * HOC для отключения SSR с опциональным лоадером
 * @param {React.ComponentType} WrappedComponent - Компонент, который рендерится только на клиенте
 * @param {React.ComponentType} [Loader] - Заглушка для серверного рендера
 */
export default function withoutSSR(WrappedComponent, Loader = () => null) {
  function WithoutSSR(props) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
      setIsClient(true);
    }, []);

    return isClient ? (
      <WrappedComponent {...props} />
    ) : (
      <Loader {...props} />
    );
  }

  WithoutSSR.displayName = `withoutSSR(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithoutSSR;
}
